class Context {

  constructor () {
    this._endpoints = {
      token: 'https://ff-lumen-api-dev.herokuapp.com/auth/accesstoken'
    };

    this._routes = {
      login: '/login',
      home: '/'
    };

    this._store = null;
  }

  get store () {
    return this._store;
  }

  set store (store) {
    this._store = store;
  }

  get endpoints () {
    return this._endpoints;
  }

  set endpoints (endpoints) {
    this._endpoints = Object.assign({}, this.endpoints, endpoints);
  }

  get routes () {
    return this._routes;
  }

  set routes (routes) {
    this._routes = Object.assign({}, this.routes, routes);
  }
}

export default new Context();



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/context.js
 **/